import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { GetVesselsResponse, VesselModel } from "../models/my-vessels.models";

@autoinject
export class MyVesselApi {

    public myVesselApi: string = `${this.configService.config.urls.myVesselsApiUrl}/api/v1/MyVessel`;
    
    constructor(private requestClientService: RequestClientService, private configService: ConfigService) { }

    //Get my vessels
    public async getMyVessels(vesselTypeGroupId?:number, includeTypeGroup? : boolean, customerLevel?:boolean): Promise<GetVesselsResponse> {
        try {
            return await this.requestClientService.get<GetVesselsResponse>(`${this.myVesselApi}/GetMyVessels`, {
                vesselGroupId:vesselTypeGroupId,
                customerLevel:customerLevel, 
                includeTypeGroup: includeTypeGroup
            });
        }
        catch (e) {
            console.error(e);
        }
    }

    public async getVessels(vesselIds: number[]): Promise<VesselModel[]>
    {
        try {
            const batchSize = 50;
            const promises: Promise<any>[] = [];
            const vesselModels: VesselModel[] = [];

            for (let i = 0; i < vesselIds.length; i += batchSize) {
                const batch = vesselIds.slice(i, i + batchSize);
                const vesselIdsStr = batch.join(',');
                const query = `${this.configService.config.urls.rightShipPlatformApiUrl}/odata/AllVesselSearch?filter=VesselId in (${vesselIdsStr})`;
                promises.push(this.requestClientService.get<any>(query));
            }

            const results = await Promise.allSettled(promises);
            results.forEach(result => {
                if (result.status === 'fulfilled') {
                    vesselModels.push(...result.value.value.map(x => {
                        return {
                            vesselId: x.vesselId,
                            vesselName: x.name,
                            dwt: x.dwt,
                            vesselType: x.vesselType,
                            internationalMaritimeOrganizationNumber: x.internationalMaritimeOrganizationNumber,
                            vehicleIdentificationNumber: x.vehicleIdentificationNumber,
                            europeanNumberOfIdentification: x.europeanNumberOfIdentification,
                            maritimeMobileServiceIdentityNumber: x.maritimeMobileServiceIdentityNumber,
                            typeGroupId: x.vesselTypeGroupId
                        };
                    }));
                } else {
                    console.warn("some vessels could not be fetched");
                }
            });

            return vesselModels;
        }
        catch (e) {
            console.error(e);
        }
    }
}
